module.exports = __webpack_public_path__ + "static/media/time-cost-quality-card.00a2140b.jpg";